import { useQuery, useQueryClient } from '@tanstack/react-query';
import { errorText } from '../api/client';
import { SAMPLE_DATA } from './sample';

/**
 * A list of records (customers, agents, carriers…) shared by every page that shows it.
 * With `load` they come from the server (the Serb Mind vault); without it, from the sample data.
 * Records added in the browser are kept here, but not in the vault yet.
 */
export function useRecords<T>(key: string, sample: T[], load?: () => Promise<T[]>) {
  const qc = useQueryClient();
  const q = useQuery({
    queryKey: [key],
    queryFn: load ?? (async () => (SAMPLE_DATA ? sample : [])),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
  });
  return {
    items: q.data ?? [],
    loading: q.isPending,
    error: q.isError ? errorText(q.error, 'This list could not be loaded.') : '',
    add: (item: T) => qc.setQueryData<T[]>([key], (all = []) => [item, ...all]),
  };
}
